import { SystemTypeRaw } from '@innovyze/lib_asset_schema';
import { createAction } from 'redux-actions';
import { addNamespace } from './utils';

/**
 * Action to get a system schema.
 * @param systemType - The type of the system.
 */
export const getSystemSchemaAction = createAction(
	addNamespace('systemSchema/getSystemSchema'),
	(systemType: string) => systemType,
);

/**
 * Action dispatched when the system schema is successfully retrieved.
 * @internal
 */
export const getSystemSchemaResolved = createAction<SystemTypeRaw>(
	addNamespace('systemSchema/getSystemSchema/resolved'),
);

/**
 * Action dispatched when there is an error retrieving the system schema.
 * @internal
 */
export const getSystemSchemaRejected = createAction(
	addNamespace('systemSchema/getSystemSchema/rejected'),
);

/**
 * Action to get all system schemas.
 */
export const getAllSystemsSchemaAction = createAction(
	addNamespace('systemSchema/getAllSystemsSchema'),
);

/**
 * Action dispatched when all system schemas are successfully retrieved.
 * @internal
 */
export const getAllSystemsSchemaResolved = createAction<SystemTypeRaw[]>(
	addNamespace('systemSchema/getAllSystemsSchema/resolved'),
);

/**
 * Action dispatched when there is an error retrieving all system schemas.
 * @internal
 */
export const getAllSystemsSchemaRejected = createAction(
	addNamespace('systemSchema/getAllSystemsSchema/rejected'),
);
